"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _DocumentedComponent = require("../../types/DocumentedComponent");
var _utils = require("../utils");
var _TooltipProvider = _interopRequireDefault(require("./TooltipProvider"));
var _TooltipTrigger = _interopRequireDefault(require("./TooltipTrigger"));
var _interfaces = require("./interfaces");
var _propTypes2 = require("./propTypes");
var _react2 = require("@emotion/react");
const withTooltip = function () {
  let {
    defaultTooltipText,
    triggerVerticalAlign,
    useTriggerWrapper = true
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return WrappedComponent => {
    const ComponentWithTooltip = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
      let {
        isInline = false,
        tooltipText = defaultTooltipText,
        tooltipPosition,
        tooltipAlignment,
        tooltipDataTestId,
        onOpened,
        onClosed,
        delayOnHoverDuration,
        ...passthroughProps
      } = _ref;
      return (0, _react2.jsx)(_TooltipProvider.default, {
        tooltipText: tooltipText || '',
        tooltipPosition: tooltipPosition,
        tooltipAlignment: tooltipAlignment,
        tooltipDataTestId: tooltipDataTestId,
        onOpened: onOpened,
        onClosed: onClosed
      }, _ref2 => {
        let {
          open,
          close,
          tooltipId,
          triggerRef,
          tooltipRef,
          isOpen
        } = _ref2;
        return (0, _react2.jsx)(_TooltipTrigger.default, (0, _extends2.default)({
          isInline: isInline,
          WrappedComponent: WrappedComponent,
          useTriggerWrapper: useTriggerWrapper,
          tooltipDataTestId: tooltipDataTestId,
          isOpen: isOpen,
          open: open,
          close: close,
          tooltipId: tooltipId,
          triggerRef: triggerRef,
          tooltipRef: tooltipRef,
          verticalAlign: triggerVerticalAlign,
          externalRef: ref,
          delayOnHoverDuration: delayOnHoverDuration
        }, passthroughProps));
      });
    });
    const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    ComponentWithTooltip.displayName = "withTooltip(".concat(displayName, ")");
    if (WrappedComponent.defaultProps) {
      ComponentWithTooltip.defaultProps = {
        ...WrappedComponent.defaultProps
      };
    }
    const description = (0, _DocumentedComponent.isDocumentedComponent)(WrappedComponent) ? WrappedComponent.documentation.toJSON().description : '';
    const DocumentedComponentWithTooltip = (0, _stencilReactDesc.describe)(ComponentWithTooltip).description(description);
    if ((0, _DocumentedComponent.isDocumentedComponent)(WrappedComponent)) {
      const tooltipText = !!defaultTooltipText ? _stencilReactDesc.PropTypes.oneOfType(_propTypes2.tooltipTextTypes).description(_propTypes2.tooltipTextDescription) : _stencilReactDesc.PropTypes.oneOfType(_propTypes2.tooltipTextTypes).isRequired.description(_propTypes2.tooltipTextDescription);
      DocumentedComponentWithTooltip.propTypes = {
        ...WrappedComponent.describedPropTypes,
        tooltipText,
        ...(0, _utils.omit)(_TooltipProvider.default.describedPropTypes, ['isInline', 'tooltipText', 'children'])
      };
    } else if (WrappedComponent.propTypes) {
      const tooltipTextReactTypes = [_propTypes.default.element, _propTypes.default.string];
      const tooltipText = !!defaultTooltipText ? _propTypes.default.oneOfType(tooltipTextReactTypes) : _propTypes.default.oneOfType(tooltipTextReactTypes).isRequired;
      ComponentWithTooltip.propTypes = {
        ...WrappedComponent.propTypes,
        tooltipText,
        tooltipPosition: _propTypes.default.oneOf(Object.values(_interfaces.TOOLTIP_POSITION)),
        tooltipDataTestId: _propTypes.default.string
      };
    }
    return DocumentedComponentWithTooltip;
  };
};
var _default = exports.default = withTooltip;